module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/frat-elements-a2a04142dc9fb271340d43f4ff2c23d5.webp";